"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbilityEnabledEventArgs = void 0;
const EventType_1 = require("../EventType");
class AbilityEnabledEventArgs {
    constructor(slot) {
        this.slot = slot;
        this.__type = EventType_1.EventType.AbilityEnabled;
        this.__typeName = "AbilityEnabled";
    }
}
exports.AbilityEnabledEventArgs = AbilityEnabledEventArgs;
